import { useQuery } from '@tanstack/react-query'
import { RETAILER_AGENT_BASE_URL, getSessionToken } from './config'

export interface ConversationSession {
  session_id: string
  title: string
  last_active_at: string
}

async function fetchSessions(partnerId: string): Promise<ConversationSession[]> {
  const response = await fetch(`${RETAILER_AGENT_BASE_URL}/sessions`, {
    headers: {
      Authorization: `Bearer ${getSessionToken() ?? ''}`,
      'X-IPP-Partner-Ids': partnerId,
    },
  })
  if (!response.ok) return []
  const data = (await response.json()) as { sessions: ConversationSession[] }
  return data.sessions ?? []
}

export function useConversationHistory(partnerId: string, refreshTrigger: number) {
  const { data, isLoading } = useQuery({
    queryKey: ['retailer-agent-sessions', partnerId, refreshTrigger],
    queryFn: () => fetchSessions(partnerId),
    enabled: Boolean(partnerId),
  })

  return { sessions: data ?? [], isLoading }
}
